import styled from "styled-components";

export const InviteContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 20px;
  min-height: calc(100vh - 120px);
`;

export const InviteLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InviteHeader = styled.div``;

export const InviteLinkBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #7b36ee;
  width: calc(100% - 40px);
  height: 50px;
  cursor: text;
  margin-block: 20px;
  border-radius: 10px;
`;

export const InviteCopyButton = styled.button`
  height: 50px;
`;
